import customer from './customer.ts';
import customerLocation from './customerLocation.ts';
import customerLocationGlobalLocationNumber from './customerLocationGlobalLocationNumber.ts';
import documentException from './documentException.ts';
import fastspring from './fastspring.ts';
import file from './file.ts';
import illegitReport from './illegitReport.ts';
import med from './med.ts';
import order from './order.ts';
import outboundDocument from './outboundDocument.ts';
import outboundDocumentStatus from './outboundDocumentStatus.ts';
import recall from './recall.ts';
import state from './state.ts';
import tradingPartner from './tradingPartner.ts';
import user from './user.ts';
import userCustomerLocation from './userCustomerLocation.ts';
import verifiedTradingPartner from './verifiedTradingPartner.ts';

const api = {
  customer,
  customerLocation,
  customerLocationGlobalLocationNumber,
  documentException,
  fastspring,
  file,
  illegitReport,
  med,
  order,
  outboundDocument,
  outboundDocumentStatus,
  recall,
  state,
  tradingPartner,
  user,
  userCustomerLocation,
  verifiedTradingPartner,
};

export default api;
